<template>
  <div
    class="overlay-wrapper">
    <slot></slot>
    <div
      :style="styling"
      class="overlay-wrapper__dimmer"
      @click.self="closeOverlays()"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { TweenMax } from "gsap";

export default {
  name: "OverlayWrapper",
  data () {
    return {
      styling: {
        opacity: 0,
        visibility: "hidden"
      }
    };
  },
  computed: {
    anyOpenOverlays () {
      return this.overlays.some( x => x.open );
    },
    ...mapState( {
      overlays: state => state.overlay.overlays
    } )
  },
  watch: {
    anyOpenOverlays ( value ) {
      if ( !value ) {
        const vm = this;

        TweenMax.to( this.styling, 0.2, {
          opacity: 0,
          onComplete: () => {
            vm.styling.visibility = "hidden";
          }
        } );

        document.querySelector( "body" ).classList.remove( "open-overlay" );
      } else {
        this.styling.visibility = "visible";

        TweenMax.to( this.styling, 0.2, {
          opacity: 1
        } );

        document.querySelector( "body" ).classList.add( "open-overlay" );
      }
    }
  },
  methods: {
    closeOverlays () {
      if ( this.anyOpenOverlays ) {
        this.overlays.forEach( x => {
          const payload = {
            alias: x.alias
          };

          this.$store.dispatch( "closeOverlay", payload );
        } );
      }
    }
  }
};
</script>

<style lang="less" scoped>
  .overlay-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }

  .overlay-wrapper__dimmer {
    position: fixed;
    top: -50px;
    bottom: -50px;
    left: -50px;
    right: -50px;
    opacity: 0;
    will-change: opacity;
  }
</style>
